import axios from '@dap/shared-utils/http.js';

export default {
    getEffectTable (region = 'china', params) {
        return axios.post(`/dapper/api/insights/ad_material/material_effect/${region}`, params);
    },
    getEffectRsvTable (region = 'china', params) {
        return axios.post(`/dapper/api/insights/ad_material/material_effect/rsv/${region}`, params);
    },

    getReAttributionTable (params) {
        return axios.post('/dapper/api/insights/ad_material/material_effect/remkt-china', params);
    },

    getDict (params = {}) {
        return axios.get('/dapper/api/insights/ad_material/filter_config', {
            params,
        });
    },

    getValueList (url, params) {
        return axios.get(url, { params });
    },
};
